<template>
  <div v-bind:class="{ paddingContent: isSidebarShow, nonPaddingContent: !isSidebarShow }">
    <div class="container">
      <div class="breadCrumbsContainer" style="display: flex;">
        技能者管理　
        <div class="headerBtn" @click="add" v-if="role ==='business' || role ==='branch'">新規登録</div>
        <!-- <div class="headerBtn" @click="openModal(4)" v-if="role==='business'">転入手続き</div> -->
        <div class="headerBtn" @click="bulkAdd" v-if="role==='business' || role ==='branch'">一括登録</div>
      </div>

      <div class="row">
        <p class="inputTitle condition">ログインID</p>
        <multiselect
          v-model="loginIdCondition"
          :options="loginIdOptions"
          :multiple="true"
          :taggable="true"
          placeholder="検索したいログインIDを入力"
          selectLabel="選択"
          deselectLabel="解除"
          selectedLabel="選択済"
          label="name"
          track-by="code"
          style="margin: auto"
          @tag="addLoginIdTag">
        >
        <span slot="noOptions"></span>
        </multiselect>
        <!-- 選択されたタグの情報確認用 -->
        <!-- <pre class="language-json"><code>{{ siteCondition  }}</code></pre> -->
      </div>

      <div class="row">
        <p class="inputTitle condition">技能者名</p>
        <multiselect
          v-model="nameCondition"
          :options="nameOptions"
          :multiple="true"
          :taggable="true"
          placeholder="検索したい技能者名を入力"
          selectLabel="選択"
          deselectLabel="解除"
          selectedLabel="選択済"
          label="name"
          track-by="code"
          style="margin: auto"
          @tag="addNameTag">
        >
        <span slot="noOptions"></span>
        </multiselect>
        <!-- 選択されたタグの情報確認用 -->
        <!-- <pre class="language-json"><code>{{ siteCondition  }}</code></pre> -->
      </div>

      <div class="searchBtn" @click="search()">検索</div>
      <!-- ローディング -->
      <div v-if="getLodingFlg || postLodingFlg || putLodingFlg || deleteLodingFlg">
        <vue-loading type="cylon" color="#1b7e47" :size="{ width: '150px', height: '150px' }">
        </vue-loading>
        <div style="padding: 0px 0px 30px 0px;" v-if="getLodingFlg">Now loading...</div>
        <div style="padding: 0px 0px 30px 0px;" v-if="postLodingFlg">Now registering...</div>
        <div style="padding: 0px 0px 30px 0px;" v-if="putLodingFlg">Now updateing...</div>
        <div style="padding: 0px 0px 30px 0px;" v-if="deleteLodingFlg">Now deleting...</div>
      </div>
      <!-- エラー表示 -->
      <div v-if="getErrorFlg || postErrorFlg || putErrorFlg || deleteErrorFlg"
       style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <!-- 取得エラー表示 -->
          <div class="errSpan" style="font-size:x-large;" v-if="getErrorFlg">
            {{errorMessage}}
          </div>
          <!-- 登録エラー表示 -->
          <div class="errSpan" style="font-size:x-large;" v-if="postErrorFlg">
            データの登録中に問題が発生しました。
          </div>
          <!-- 更新エラー表示 -->
          <div class="errSpan" style="font-size:x-large;" v-if="putErrorFlg">
            データの更新中に問題が発生しました。
          </div>
          <!-- 削除エラー表示 -->
          <div class="errDiv" style="font-size:x-large;" v-if="deleteErrorFlg">
            データの削除中に問題が発生しました。
          </div>
        </div>
      </div>
      <!-- 現在表示件数 / 検索結果最大件数 -->
      <div style="text-align:right" v-if="!getLodingFlg && !getErrorFlg">
        <div v-if="limit * currentPage <= maxCount">
          {{(limit * currentPage) - (limit - 1)}} - {{limit * currentPage}} / {{maxCount}} 件
        </div>
        <div v-else>
          {{(limit * currentPage) - (limit - 1)}} - {{maxCount}} / {{maxCount}} 件
        </div>
      </div>
      <!-- ページネーション -->
      <div class="vgt-wrap__footer vgt-clearfix" v-if="!getLodingFlg && !getErrorFlg">
        <div class="footer__navigation vgt-pull-right">
          <div class="footer__navigation__page-info">
            <label for="vgt-page-input1" class="page-info__label">
              <span>ページ</span>
              <input id="vgt-page-input1" aria-controls="vgb-table" type="text"
               v-model="inputPage" @keypress.enter="paginationInput" @blur="paginationBlue"
               class="footer__navigation__page-info__current-entry">
               <span>/ {{maxPage}}</span>
             </label>
          </div>
          <button type="button" aria-controls="vgt-table"
            class="footer__navigation__page-btn" @click="pagination('back')"
            v-bind:class="{
              disabled: currentPage <= 1
            }"
            :disabled="currentPage <= 1">
            <span aria-hidden="true" class="chevron left"></span>
            <span>前へ</span>
          </button>
          <button type="button" aria-controls="vgt-table"
            class="footer__navigation__page-btn" @click="pagination('next')"
            v-bind:class="{
              disabled: currentPage >= maxPage
            }"
            :disabled="currentPage >= maxPage">
            <span>次へ</span>
            <span aria-hidden="true" class="chevron right"></span>
          </button>
        </div>
      </div>
      <!-- 事業者画面 -->
      <div v-if="role==='business'">
        <vue-good-table
        ref="business-table"
        :columns='columns'
        :rows='rows'
        :isLoading.sync="lodingFlg"
        :select-options="{
          enabled: false,
          selectOnCheckboxOnly: true,
          selectionText: '選択中',
          clearSelectionText: '選択を解除',
        }"
        :group-options="{
          enabled: false
        }"
        @on-sort-change="onSortChange"
        @on-cell-click="openDetail"
        @on-selected-rows-change="selectionChanged"
        v-if="!getLodingFlg && !getErrorFlg"
        >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'operation'" style="display: flex;">
            <div class="edit" @click.stop="edit(props.formattedRow)">編集</div>
            <div class="remove" @click.stop="beforeOpenModal(props.formattedRow, 3)">削除</div>
            <!-- <div class="remove" style="width: 108px" @click.stop="beforeOpenModal(props.formattedRow, 3)" v-if="!props.row.ccusWorkerId">削除</div> -->
            <div class="branchChange" @click.stop="beforeOpenModal(props.formattedRow, 7)">支店変更</div>
          </span>
          <span v-else-if="props.column.field === 'branchName'" style="display: flex;">
            <div v-if="!props.formattedRow[props.column.field]">未登録</div>
            <div v-else>{{props.formattedRow[props.column.field]}}</div>
          </span>
          <span v-else-if="props.column.field === 'email'" style="display: flex;">
            <div v-if="!props.formattedRow[props.column.field]" class="nonRegister" @click.stop="beforeOpenModal(props.formattedRow, 1)">登録する</div>
            <div v-else>
              {{props.formattedRow[props.column.field]}} <div class="registered">利用登録済</div>
            </div>
          </span>
          <span v-else-if="props.column.field === 'ccusWorkerId'" style="display: flex;">
            <div v-if="!props.formattedRow[props.column.field]" class="nonRegister" @click.stop="beforeOpenModal(props.formattedRow, 2)">登録する</div>
            <div v-else>{{props.formattedRow[props.column.field]}}</div>
          </span>
          <span v-else>{{props.formattedRow[props.column.field]}}</span>
        </template>
        <div slot="selected-row-actions">
          <button type="button" class="remove" @click.once="bulkDelete" style="line-height: 20px;">一括削除</button>
        </div>
        <div slot="emptystate">データがありません</div>
      </vue-good-table>
    </div>
    <!-- 支店管理者 -->
    <div v-if="role==='branch'">
      <vue-good-table
      ref="branch-table"
      :columns='branchColumns'
      :rows='rows'
      :isLoading.sync="lodingFlg"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true,
        selectionText: '選択中',
        clearSelectionText: '選択を解除',
      }"
      :group-options="{
        enabled: false
      }"
      @on-sort-change="onSortChange"
      @on-cell-click="openDetail"
      @on-selected-rows-change="selectionChanged"
      v-if="!getLodingFlg && !getErrorFlg"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'operation'" style="display: flex;">
            <div class="edit" @click.stop="edit(props.formattedRow)">編集</div>
            <div class="remove" style="width: 108px" @click.stop="beforeOpenModal(props.formattedRow, 3)">削除</div>
            <div class="branchChange" @click.stop="beforeOpenModal(props.formattedRow, 7)">支店変更</div>
          </span>
          <span v-else-if="props.column.field === 'branchName'" style="display: flex;">
            <div v-if="!props.formattedRow[props.column.field]">未登録</div>
            <div v-else>{{props.formattedRow[props.column.field]}}</div>
          </span>
          <span v-else-if="props.column.field === 'email'" style="display: flex;">
            <div v-if="!props.formattedRow[props.column.field]" class="nonRegister" @click.stop="beforeOpenModal(props.formattedRow, 1)">登録する</div>
            <div v-else>
              {{props.formattedRow[props.column.field]}} <div class="registered" style="width: 80px">利用登録済</div>
            </div>
          </span>
          <span v-else-if="props.column.field === 'ccusWorkerId'" style="display: flex;">
            <div v-if="!props.formattedRow[props.column.field]" class="nonRegister" style="width: 80px" @click.stop="beforeOpenModal(props.formattedRow, 2)">登録する</div>
            <div v-else>{{props.formattedRow[props.column.field]}}</div>
          </span>
          <span v-else>{{props.formattedRow[props.column.field]}}</span>
        </template>
        <div slot="selected-row-actions">
          <button type="button" class="remove" @click.once="bulkDelete" style="line-height: 20px;">選択データを削除</button>
        </div>
        <div slot="emptystate">データがありません</div>
      </vue-good-table>
    </div>
    <!-- 運営管理画面 -->
    <div v-if="role==='admin'">
      <vue-good-table
        ref="my-table"
        :columns='adminColumns'
        :rows='rows'
        :isLoading.sync="lodingFlg"
        :group-options="{
          enabled: false
        }"
        @on-sort-change="onSortChange"
        @on-cell-click="openDetail"
        v-if="!getLodingFlg && !getErrorFlg"
      >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'email'" style="display: flex;">
          <div v-if="props.formattedRow[props.column.field] === ''" class="nonRegister" @click.stop="openModal(1)">登録する</div>
          <div v-else>
            {{props.formattedRow[props.column.field]}} <div class="register" style="width: 80px">利用登録済</div>
          </div>
          <span v-else>{{props.formattedRow[props.column.field]}}</span>
        </span>
      </template>
      <div slot="emptystate">データがありません</div>
      </vue-good-table>
    </div>
    
      <!-- ローディング -->
      <div v-if="csvGetLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div style="padding: 0px 0px 30px 0px;">Now loading...</div>
        <div style="padding: 0px 0px 30px 0px;">データの取得には時間を要する場合がございます。</div>
      </div>
      <!-- 取得エラー表示 -->
      <div v-if="csvGetErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            {{csvGetErrorMessage}}
          </div>
        </div>
      </div>
      <button type="button" class="csvBtn" @click="callOutputCsv()"
        :disabled="!csvDlFlg && !csvGetLodingFlg || maxCount > csvLimit"
        v-bind:class="{ disabled: !csvDlFlg || maxCount > csvLimit, active: csvDlFlg && maxCount <= csvLimit}">
        表示中のデータをCSV形式でダウンロード
      </button>
      <div　style="text-align:right">
        ※CSVダウンロード件数は最大{{csvLimit}}件になります。<br>
        　件数を超えている場合は検索条件にて絞り込みを行ってください。
      </div>
  </div>
    <!-- メールアドレスモーダル画面 -->
    <Modal size="email" @close="closeModal(1)" v-if="idModal">
      <p class="modalTitle">メールアドレス登録</p>
      <div style="text-align:left; margin: 0px 30px 0px 30px; font-weight: bold;">
        <p>
          ご入力のメールアドレス宛に登録通知が送信されます。
        </p>
      </div>
      <form>
        <validation-observer ref="obs" v-slot="ObserverProps">
          <!-- ローディング -->
          <div v-if="postLodingFlg">
            <vue-loading type="cylon" color="#1b7e47" :size="{ width: '150px', height: '150px' }">
            </vue-loading>
            <div style="padding: 0px 0px 30px 0px;" v-if="postLodingFlg">Now registering...</div>
          </div>
          <div style="padding-left:40px;" v-else>
            <div class="inputTitle" style="display: flex;">
              メールアドレス
            </div>
            <div class="row">
              <validation-provider name="メールアドレス" rules="required|emailVaridate|max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="regMail" placeholder="xxxxxx@xxx.xxx">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
          </div>
          <div class="buttonGroup" style="margin: 40px 0px;" v-if="!postLodingFlg">
            <button type="button" class="btn" @click="emailRegistration(selectedRow.workerId, regMail, selectedRow.loginId)" style="margin:auto;"
              v-bind:class="{ disabled:isProcessing() || ObserverProps.invalid || !ObserverProps.validate, active: !ObserverProps.invalid && ObserverProps.validate }"
              :disabled="ObserverProps.invalid">登録する
              <!-- :disabled="ObserverProps.invalid || isProcessing()">登録する -->
            </button>
            <button type="button" @click="closeModal(1)" class="modalNo" style="margin-right: auto;">キャンセル</button>
          </div>
        </validation-observer>
      </form>
    </Modal>

    <!-- CCUS技能者IDモーダル画面 -->
    <Modal size="newCcusId" @close="closeModal(2)" v-if="ccusModal">
      <p class="modalTitle">CCUS技能者ID登録</p>
      <!-- ローディング -->
      <div v-if="getLodingFlg || postLodingFlg || putLodingFlg || deleteLodingFlg">
        <vue-loading type="cylon" color="#1b7e47" :size="{ width: '150px', height: '150px' }">
        </vue-loading>
        <div style="padding: 0px 0px 30px 0px;" v-if="getLodingFlg">Now loading...</div>
        <div style="padding: 0px 0px 30px 0px;" v-if="postLodingFlg">Now registering...</div>
        <div style="padding: 0px 0px 30px 0px;" v-if="putLodingFlg">Now updateing...</div>
        <div style="padding: 0px 0px 30px 0px;" v-if="deleteLodingFlg">Now deleting...</div>
      </div>
      <div style="text-align:left; margin: 0px 30px 0px 30px; font-weight: bold;">
        <p>{{selectedRow.workerName}} さんのCCUS技能者情報を入力下さい。</p>
      </div>
      <form>
        <validation-observer ref="obs" v-slot="ObserverProps">
          <div style="padding-left:40px;">
            <div class="inputTitle" style="display: flex;">
              CCUS技能者ID
            </div>
            <div class="row">
              <validation-provider name="CCUS技能者ID" rules="required|digits:14" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="regEngineerId" placeholder="例：01234567890123">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <p style="text-align: left;">CCUS登録時に発行される14桁の技能者IDです。</p>
            <div class="inputTitle" style="display: flex;">
              CCUS技能者本人確認番号
            </div>
            <div class="row">
              <validation-provider name="CCUS技能者本人確認番号" rules="required|digits:4" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="regAuthNumber" placeholder="例：0123">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <p style="text-align: left;">CCUS登録時に発行される技能者カード裏面記載の4桁の本人確認番号です。</p>
            <div class="inputTitle" style="display: flex;">
              生年月日
            </div>
            <div class="row">
              <validation-provider name="生年月日" rules="required|birthDay|pastDay" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input type="Date" max="9999-12-31" class="text large" v-model="birthdate">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <p style="text-align: left;">CCUS登録時に入力した生年月日です。</p>
          </div>
          <div class="buttonGroup" style="margin: 40px 0px;">
            <button class="btn" @click="ccusIdRegistration(selectedRow.workerId, regEngineerId, regAuthNumber, birthdate)" style="margin:auto;"
              v-bind:class="{ disabled:isProcessing() || ObserverProps.invalid || !ObserverProps.validate, active: !ObserverProps.invalid && ObserverProps.validate }"
              :disabled="ObserverProps.invalid">登録する
            </button>
            <button type="button" @click="closeModal(2)" class="modalNo" style="margin-right: auto;">キャンセル</button>
          </div>
        </validation-observer>
      </form>
    </Modal>

    <!-- 削除モーダル画面 -->
    <Modal size="delete" @close="closeModal(3)" v-if="deleteModal">
      <!-- ローディング -->
      <div v-if="getLodingFlg || postLodingFlg || putLodingFlg || deleteLodingFlg">
        <vue-loading type="cylon" color="#1b7e47" :size="{ width: '150px', height: '150px' }">
        </vue-loading>
        <div style="padding: 0px 0px 30px 0px;" v-if="getLodingFlg">Now loading...</div>
        <div style="padding: 0px 0px 30px 0px;" v-if="postLodingFlg">Now registering...</div>
        <div style="padding: 0px 0px 30px 0px;" v-if="putLodingFlg">Now updateing...</div>
        <div style="padding: 0px 0px 30px 0px;" v-if="deleteLodingFlg">Now deleting...</div>
      </div>
      <p class="modalTitle">削除しますか？</p>
      <div style="text-align:left; margin: 0px 30px 0px 30px; font-weight: bold;">
        <p>
          本当に {{selectedRow.workerName}} さんの登録を削除してよろしいですか？<br>
          入退場情報を含めた、{{selectedRow.workerName}} さんに関するデータが全て削除されます。<br>
          一度削除したデータは復旧出来ませんので、ご了承下さい。
        </p>
      </div>
      <button @click.once="deleteExecution()" class="modalYes">削除する</button>
      <button type="button" @click="closeModal(3)" class="modalNo" style="margin: 10px 0px 0px 30px;">キャンセル</button>
    </Modal>

    <!-- 詳細モーダル画面 -->
    <Modal size="worker" @close="closeModal(6)" v-if="detailModal">
      <p class="modalTitle">技能者詳細 - {{detailRow.workerName}}</p>
      <Detail :id=detailRow.workerId :name=detailRow.workerName style="padding-left: 0px;" />
      <button type="button" @click="closeModal(6)" class="branchChange" style='margin-bottom: 15px;'>閉じる</button>
    </Modal>
    <!-- 支店変更モーダル画面 -->
    <Modal size="branchChange" @close="closeModal(7)" v-if="branchChangeModal">
      <p class="modalTitle">支店を設定/変更</p>
      <div class="breadCrumbsContainer" style="display: flex;">
        {{selectedRow.workerName}} の所属する支店を入力下さい。
      </div>
      <form>
        <validation-observer ref="obs" v-slot="ObserverProps">
          <div class="row">
            <p class="inputTitle editable">支店</p>
            <validation-provider name="支店" rules="required">
              <div class="rowRight" slot-scope="ProviderProps">
                <div class="selectdiv">
                  <select  v-model="selectedBranch">
                    <option value="" selected>支店選択</option>
                    <option v-for="branch in branchNameOptions"
                    v-bind:value="branch"
                    v-bind:key="branch.id">
                    {{ branch.branchName }}
                    </option>
                  </select>
                </div>
                <div class="errMsg" v-if="ProviderProps.errors[0]">
                  <span class="errSpan">
                    {{ ProviderProps.errors[0] }}
                  </span>
                </div>
                <div class="errMsg" v-if="selectedBranch.branchId === selectedRow.branchId && selectedRow.branchId !== null">
                  <span class="errSpan">
                    既に設定済みの支店です。
                  </span>
                </div>
              </div>
            </validation-provider>
          </div>
          <div class="buttonGroup">
            <button class="btn" type='button' @click="branchChangeExecution" style="margin:auto;"
            v-bind:class="{ disabled:isProcessing() || ObserverProps.invalid || !ObserverProps.validate || selectedBranch.branchId === selectedRow.branchId,
              active: !ObserverProps.invalid && ObserverProps.validate && selectedBranch.branchId !== selectedRow.branchId}"
            :disabled="ObserverProps.invalid || selectedBranch.branchId === selectedRow.branchId">登録
            </button>
            <button type="button" @click="closeModal(7)" class="close" style="margin: auto;">閉じる</button>
          </div>
        </validation-observer>
      </form>
    </Modal>
  </div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import '../style/vue-good-table.scss';
import { VueGoodTable } from 'vue-good-table';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import Modal from './BaseModal.vue';
import Detail from './WorkerDetail.vue';
import ApiClient from '../services/ApiClient';
import { VueLoading } from 'vue-loading-template';
import common from '../services/common';

// when使用のための処理 ------ start
type ChainedWhen<T, R> = {
  on: <A>(pred: (v: T) => boolean, fn: () => A) => ChainedWhen<T, R | A>;
  otherwise: <A>(fn: () => A) => R | A;
};

const match = <T, R>(val: any): ChainedWhen<T, R> => ({
  on: <A>(pred: (v: T) => boolean, fn: () => A) => match<T,  R | A>(val),
  otherwise: <A>(fn: () => A): A | R => val,
});

const chain = <T,  R>(val: T): ChainedWhen<T,  R> => ({
  on: <A>(pred: (v: T) => boolean, fn: () => A) =>
    pred(val) ? match(fn()) : chain<T,  A | R>(val),
  otherwise: <A>(fn: () => A) => fn(),
});

const when = <T>(val: T) => ({
  on: <A>(pred: (v: T) => boolean, fn: () => A) =>
    pred(val) ? match<T,  A>(fn()) : chain<T,  A>(val),
});
// when使用のための処理 ------ end

export default {
  title: '技能者管理',
  name: 'Worker',
  components: {
    VueGoodTable,
    Modal,
    Detail,
    ValidationProvider,
    ValidationObserver,
    VueLoading,
  },
  // setup() {
  //   return {
  //   },
  // },
  data() {
    return {
      companyId: '',
      branchId: '',
      // 検索条件用
      loginIdOptions: [],
      loginIdCondition: [],
      nameOptions: [],
      nameCondition: [],
      companyOptions: [],
      companyCondition: [],
      branchNameOptions: [],
      branchNameCondition: [],
      // 選択削除用
      deleteSelectRows: [],
      // モーダル表示用フラグ
      idModal: false,
      ccusModal: false,
      deleteModal: false,
      branchChangeModal: false,
      detailModal: false,
      // 追加登録用
      regLoginId: '', // 登録メールアドレス仮データ。生成規則要確認
      regMail: '',      // 登録メール仮データ。列にメールアドレス情報を持たせる必要有。
      regEngineerId: '',            // 登録CCUS技能者ID
      regAuthNumber: '',            // 登録CCUS技能者本人確認番号
      birthdate: '',                // 登録用生年月日
      // 表示データ情報
      rows: [],
      // 選択行のデータを詰める
      detailRow: {},
      selectedRow: {},
      // ========================事業者画面========================
      columns: [
        {
          label: '所属支店',
          field: 'branchName',
          sortable: true,
          width: '120px',
        },
        {
          label: '名前',
          field: 'workerName',
          sortable: true,
          width: '120px',
        },
        {
          label: 'ログインID',
          field: 'loginId',
          sortable: true,
          width: '100px',
        },
        {
          label: 'CCUS技能者ID',
          field: 'ccusWorkerId',
          sortable: false,
          width: '140px',
        },
        {
          label: '内部ID',
          field: 'workerId',
          hidden: true,
        },
        {
          label: '所属支店ID',
          field: 'branchId',
          hidden: true,
        },
        {
          label: '年齢',
          field: 'age',
          sortable: false,
          width: '40px',
        },
        {
          label: '電話番号',
          field: 'tel',
          sortable: false,
          width: '120px',
        },
        {
          label: 'メールアドレス',
          field: 'email',
          sortable: true,
          width: '154px',
        },
        {
          label: '',
          field: 'operation',
          sortable: false,
          width: '330px',
        },
      ],
      // ========================支店管理者画面========================
      branchColumns: [
        {
          label: '名前',
          field: 'workerName',
          sortable: true,
          width: '120px',
        },
        {
          label: 'ログインID',
          field: 'loginId',
          sortable: true,
          width: '140px',
        },
        {
          label: 'CCUS技能者ID',
          field: 'ccusWorkerId',
          sortable: false,
          width: '140px',
        },
        {
          label: '内部ID',
          field: 'workerId',
          hidden: true,
        },
        {
          label: '所属支店ID',
          field: 'branchId',
          hidden: true,
        },
        {
          label: '所属支店',
          field: 'branchName',
          sortable: true,
          width: '120px',
          hidden: true,
        },
        {
          label: '年齢',
          field: 'age',
          sortable: false,
          width: '40px',
        },
        {
          label: '電話番号',
          field: 'tel',
          sortable: false,
          width: '120px',
        },
        {
          label: 'メールアドレス',
          field: 'email',
          sortable: true,
          width: '154px',
        },
        {
          label: '',
          field: 'operation',
          sortable: false,
          width: '330px',
        },
      ],
      // ========================運営管理画面========================
      adminColumns: [
        {
          label: '事業者',
          field: 'companyName',
          sortable: true,
          width: '150px',
        },
        {
          label: '所属支店',
          field: 'branchName',
          sortable: true,
          width: '120px',
        },
        {
          label: '名前',
          field: 'workerName',
          sortable: true,
          width: '140px',
        },
        {
          label: 'ログインID',
          field: 'loginId',
          sortable: true,
          width: '140px',
        },
        {
          label: 'CCUS技能者ID',
          field: 'ccusWorkerId',
          sortable: false,
          width: '140px',
        },
        {
          label: '内部ID',
          field: 'workerId',
          sortable: true,
          width: '350px',
        },
        {
          label: '登録日',
          field: 'registrationDate',
          sortable: false,
          // type: 'date',
          // dateInputFormat: 'yyyy-mm-dd',
          // dateOutputFormat: 'yyyy年mm月dd日',
          width: '140px',
          formatFn: this.callDateFormat,
        },
        {
          label: 'メールアドレス',
          field: 'email',
          hidden: true,
        },
        // {
        //   label: '',
        //   field: 'operation',
        //   sortable: false,
        // },
      ],
      detail: {
        // 作業者情報
        name: '',
        sex: '',
        postalCode: '',
        address: '',
        tel: '',
        email: '',
        // CCUS登録情報
        newCcusId: '',
        ccusSecurityCode: '',
        // 保険加入情報
        insurance: {
          health: false,               // 健康保険
          pension: true,               // 年金保険
          employment: false,           // 雇用保険
          kentai: false,               // 建退共
          tyutai: false,               // 中退共
          industrialAccident: false,   // 労災保険
        },
        // 保有資格を配列で取得？
        qualifications: [
          {
            id: 1,
            name: '技術士建設部門',
          },
          {
            id: 2,
            name: '車両系建設機械運転者',
          },
          {
            id: 3,
            name: '高所作業車運転者',
          },
        ],
      },
      // 支店選択用
      selectedBranch: {
        branchName: '',
        branchId: '',
      },
      // 支店一覧配列　本来はモーダル読込時に支店リストを取得し、その配列を詰める
      optionBranch: [
        {
          code: 1,
          name: '関東',
        },
        {
          code: 2,
          name: '関西',
        },
      ],
      csvDlFlg: false,
      // ローディング
      getLodingFlg: true,    // データ取得時ローディング用フラグ
      getErrorFlg: false,     // データ取得時エラーフラグ
      postLodingFlg: false,   // データ登録時ローディングフラグ
      postErrorFlg: false,    // データ登録時エラーフラグ
      putLodingFlg: false,    // データ更新時ローディングフラグ
      putErrorFlg: false,     // データ更新時エラーフラグ
      deleteLodingFlg: false, // データ削除時ローディングフラグ
      deleteErrorFlg: false,// データ削除時エラーフラグ
      processing: false,
      errorMessage: '',
      displayingModal: 0,
      searchCondition: {},
      sortCondition: {},
      // CSVダウンロード処理実行中フラグ
      csvGetLodingFlg: false,
      // CSVダウンロードエラーフラグ
      csvGetErrorFlg: false,
      // CSVダウンロードエラーメッセージ
      csvGetErrorMessage: false,
      // CSV取得上限
      csvLimit: 5000,
      // 検索上限
      limit: 100,
      // 検索内容最大件数
      maxCount: 0,
      // 現在ページ
      currentPage: 1,
      // 現在ページ
      inputPage: 1,
      // 最大ページ数
      maxPage: 1,
      // ソートローディングフラグ
      lodingFlg: false,

    };
  },
  // 初期処理
  async mounted() {
    // セッション情報からログイン事業者IDを取得
    if (this.role === 'business') {
      this.companyId = this.$store.getters.session.companyId;
    }else if (this.role === 'branch') {
      this.companyId = this.$store.getters.session.companyId;
      this.branchId = this.$store.getters.session.branchId;
    }
    try {
      // 技能者一覧取得API呼出
      await this.callGetWorkersList();
      // 事業者リスト取得API呼出
      this.companyOptions = await this.callGetCompaniesNameList();
      // 支店リスト取得API呼出
      await this.callGetBranchsNameList();
      // 検索条件を取得
      this.loginIdCondition = common.getUrlParam('loginId', 0);
      this.nameCondition = common.getUrlParam('name', 0);
      // 検索処理呼出
      await this.search();
    } catch (error) {
      console.log('ERROR: ', error);
      this.errorMessage = error.message;
      this.getErrorFlg = true;
    } finally {
      // ローディング非表示
      this.getLodingFlg = false;
    }
  },
  computed: {
    role() {
      return this.$store.getters.session.role;
    },
    isSidebarShow() {
      return this.$store.getters.session.isSidebarShow;
    },
    getPaginateCount () {
      return Math.ceil(this.maxCount / this.limit);
    },
  },
  watch: {
    role() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
    isSidebarShow() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
  },
  methods: {
    // 技能者一覧取得API呼び出し
    async callGetWorkersList() {
      this.getErrorFlg = false;
      try {
        this.searchCondition['companyId'] = this.companyId;
        this.searchCondition['branchId'] = this.branchId;
        const restResourceService = new ApiClient();
        const result = await restResourceService.getWorkersList(this.limit,this.currentPage,this.searchCondition,this.sortCondition);
        // エポックミリ秒をYYYY-MM-DDに変換
        result.workers.forEach((worker, index) => {
          result.workers[index].registrationDate = common.dateFormatHyphen(worker.registrationDate),
          result.workers[index].age = common.ageConversion(worker.birthdate)
        });
        this.rows = result.workers;
        // テーブルデータをセット
        this.maxCount = result.maxCount;
        this.maxPage = Math.ceil(this.maxCount / this.limit);
        this.csvDlFlg = (this.rows.length > 0) ? true : false;
      } catch (error) {
        this.errorMessage = error.message;
        throw error;
      }
    },
    // 日時値を年月日（YYYY年MM月DD日）に変換
    callDateFormat(value) {
      return common.dateFormat(value);
    },
    // 事業者リスト取得API呼び出し
    async callGetCompaniesNameList() {
      try {
        switch (this.role) {
          case 'admin':
            const restResourceService = new ApiClient();
            return await restResourceService.getCompaniesNameList();
            break;
          case 'business':
            break;
          case 'branch':
            break;
          case 'worker':
            break;
          default:
            break;
        }
      } catch (error) {
        this.errorMessage = error.message;
        throw error;
      }
    },
    // 支店名リスト取得API呼び出し
    async callGetBranchsNameList() {
      try {
        const restResourceService = new ApiClient();
        switch (this.role) {
          case 'admin':
            this.branchNameOptions = await restResourceService.getBranchesNameList(this.companyId);
            break;
          case 'business':
            this.branchNameOptions = await restResourceService.getBranchesNameList(this.companyId);
            break;
          case 'branch':
            this.branchNameOptions = await restResourceService.getBranchesNameList(this.companyId);
            break;
          case 'worker':
            break;
          default:
            break;
        }
      } catch (error) {
        this.errorMessage = error.message;
        throw error;
      }
    },
    // 検索条件：ログインID追加
    addLoginIdTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000)),
      };
      this.loginIdCondition.push(tag);
      this.loginIdOptions.push(tag);
    },
    // 検索条件：名前追加
    addNameTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000)),
      };
      this.nameCondition.push(tag);
      this.nameOptions.push(tag);
    },
    // 検索ボタン押下時処理　一覧上部の検索条件を一覧へ反映
    async search() {
      // 一覧取得用の検索条件を詰める
      this.setCondition();
      // 検索条件をURLに詰める
      common.setUrlParam('loginId', this.loginIdCondition, 0);
      common.setUrlParam('name', this.nameCondition, 0);
      try {
        // ローディング表示
        this.getLodingFlg = true;
        this.currentPage = 1;
        this.inputPage = this.currentPage;
        // 技能者一覧取得API呼出
        await this.callGetWorkersList();
      } catch (error) {
        throw error;
      } finally {
        // テーブルが空の場合CSVダウンロードを非活性
        this.csvDlFlg = (this.rows.length > 0) ? true : false;
        // ローディング非表示
        this.getLodingFlg = false;
      }
    },
    // 一覧上部の検索条件を一覧へ反映
    setCondition(rows) {
      this.ccusSentConditionErr = [];
      // 検索条件初期化
      if (this.searchCondition.loginId) delete this.searchCondition.loginId;
      if (this.searchCondition.workerName) delete this.searchCondition.workerName;

      // 検索条件が設定されていない場合はreturn
      if (this.loginIdCondition.length === 0 && this.nameCondition.length === 0) {
        return;
      }
      // 検索条件：ログインID（部分一致）
      if (this.loginIdCondition.length !== 0) {
        this.searchCondition.loginId = [];
        for (const loginId of this.loginIdCondition) {
          this.searchCondition.loginId.push(loginId.name);
        }
      }
      // 検索条件：技能者名（部分一致）
      if (this.nameCondition.length !== 0) {
        this.searchCondition.workerName = [];
        for (const workerName of this.nameCondition) {
          this.searchCondition.workerName.push(workerName.name);
        }
      }
    },

    // 技能者新規登録画面へ遷移
    add() {
      this.$router.push('/workers/add');
    },
    // 技能者一括登録画面へ遷移
    bulkAdd() {
      this.$router.push('/workers/bulkAdd');
    },
    // 技能者-編集画面
    edit(params) {
      this.$router.push({
        name: 'WorkerEdit',
        params: {
          id: params.workerId,
          loginId: params.loginId,
          name: params.workerName,
        },
      });
    },
    // 技能者詳細画面へ遷移
    openDetail(params) {
      this.detailRow = params.row;
      // 運用管理者
      if (this.$store.getters.session.role === 'admin') {
        this.$router.push({
          name: 'WorkerDetail',
          params: {
            id: this.detailRow.workerId,
            name: this.detailRow.workerName,
          },
        });
      // 運営管理者以外
      } else {
        this.openModal(6);
      }
    },
    // 削除実行
    async deleteExecution() {
      try {
        const workers = [this.selectedRow.workerId];
        this.deleteErrorFlg = false;
        this.deleteLodingFlg = true;
        const restResourceService = new ApiClient();
        // 技能者削除API呼び出し
        await restResourceService.deleteWorkers(workers);
        await this.$cognito.deleteUsers([this.selectedRow.loginId])
        // 技能者一覧再取得
        await this.callGetWorkersList();
      } catch (error) {
        this.errorMessage = error.message;
        this.deleteErrorFlg = true;
      } finally {
        this.closeModal(3);
        this.deleteLodingFlg = false;
      }
    },
    // メールアドレス登録
    async emailRegistration(workerId, email, loginId) {
      try {
        // ボタン非活性化
        await this.startProcessing();
        this.postErrorFlg = false;
        this.postLodingFlg = true;
        const body = {
          loginId,
          email: '',
          newEmail: email,
          role: 'worker',
        };
        // メールアドレス登録API呼び出し
        const restResourceService = new ApiClient();
        await restResourceService.patchAccountEmail(body);

        // メール送信API呼出
        // メールに使用するTemplateData
        const templateData = {
          oldMail: '未登録',
          newMail: email
        };
        await restResourceService.changeMail(email, templateData);
        // 技能者一覧再取得
        const resGetList = await this.callGetWorkersList();
        this.rows = resGetList;
        this.regMail = '';
      } catch (error) {
      this.errorMessage = error.message;
      this.postErrorFlg = true;
      this.endProcessing();
      } finally {
        this.closeModal(1);
        this.postLodingFlg = false;
        this.endProcessing();
      }
    },
    // CCUS技能者ID登録
    async ccusIdRegistration(workerId, newCcusId, ccusSecurityCode, birthdate) {
      try {
        // ボタン非活性化
        await this.startProcessing();
        this.postErrorFlg = false;
        this.postLodingFlg = true;
        const body = {
          workerId,
          newCcusId,
          ccusSecurityCode,
          birthdate,
        };
        const restResourceService = new ApiClient();
        // CCUS技能者ID登録API呼び出し
        await restResourceService.patchWorkerCcus(body);
        // 技能者一覧再取得
        const resGetList = await this.callGetWorkersList();
        this.rows = resGetList;
      } catch (error) {
      this.errorMessage = error.message;
      this.postErrorFlg = true;
      this.endProcessing();
      } finally {
        this.closeModal(2);
        this.postLodingFlg = false;
        this.endProcessing();
      }
    },
    // 支店変更実行
    async branchChangeExecution() {
      try {
        // ボタン非活性化
        await this.startProcessing();
        this.putErrorFlg = false;
        this.putLodingFlg = true;
        const restResourceService = new ApiClient();
        // 支店変更API呼び出し
        await restResourceService.patchWorkerBranch(
          this.selectedRow.workerId,
          this.selectedBranch.branchId);
        // 技能者一覧再取得
        this.rows = await this.callGetWorkersList();
      } catch (error) {
      this.errorMessage = error.message;
      this.postErrorFlg = true;
      this.endProcessing();
      } finally {
        this.closeModal(7);
        this.putLodingFlg = false;
        this.endProcessing();
      }
    },
    // モーダルを開く前処理
    beforeOpenModal(val, num) {
      this.selectedRow = val;
      if (num === 7) {
        this.selectedBranch = {
          branchName: val.branchName,
          branchId: val.branchId,
        };
      }
      this.openModal(num);
    },
    // モーダルを開く
    openModal(num) {
      this.displayingModal = num;
      window.history.pushState(null, null, null);
      window.addEventListener('popstate', this.modalBack);
      when(num)
        .on((v) => v === 1, () => this.idModal = true)            // メールアドレス登録
        .on((v) => v === 2, () => this.ccusModal = true)          // CCUS技能者ID登録
        .on((v) => v === 3, () => this.deleteModal = true)        // 削除
        .on((v) => v === 6, () => this.detailModal = true)        // 詳細
        .on((v) => v === 7, () => this.branchChangeModal = true); // 支店変更
    },
    // モーダルを閉じる
    closeModal(num) {
      window.removeEventListener('popstate', this.modalBack);
      when(num)
        .on((v) => v === 1, () => this.idModal = false)           // メールアドレス登録
        .on((v) => v === 2, () => this.ccusModal = false)         // CCUS技能者ID登録
        .on((v) => v === 3, () => this.deleteModal = false)       // 削除
        .on((v) => v === 6, () => this.detailModal = false)       // 詳細
        .on((v) => v === 7, () => this.branchChangeModal = false); // 支店変更
    },
    // モーダル表示中ブラウザバック処理
    modalBack() {
      this.closeModal(this.displayingModal);
    },
    // チェックボックス選択行取得
    selectionChanged(v) {
      this.deleteSelectRows = v.selectedRows;
    },
    // チェックボックス選択行を一括削除
    async bulkDelete() {
      try {
        this.deleteErrorFlg = false;
        this.deleteLodingFlg = true;
        const restResourceService = new ApiClient();
        // 一括削除対象(メールアドレス未登録)のIDを詰める配列
        const deleteIdList = new Array();
        for (const deleteSelectRow of this.deleteSelectRows) {
          if (!deleteSelectRow.email) {
            deleteIdList.push(deleteSelectRow.workerId);
          }
        }
        if (deleteIdList.length !== 0) {
          // 技能者削除API呼び出し
          await restResourceService.deleteWorkers(deleteIdList);
        }
        // 技能者一覧再取得
        await this.callGetWorkersList();
      } catch (error) {
      this.errorMessage = error.message;
      this.deleteErrorFlg = true;
      } finally {
        this.deleteLodingFlg = false;
      }
    },
    // チャタリング防止
    async startProcessing() {
      this.processing = true;
    },
    async endProcessing() {
      this.processing = false;
    },
    async isProcessing() {
      return this.processing;
    },
    // CSV出力用共通関数呼出
    async callOutputCsv() {
      try {
        this.csvGetLodingFlg = true;
        window.addEventListener('beforeunload', common.confirmSave);
        // ローディングアニメ表示のために画面最下部を表示
        await this.$nextTick();
        await common.scrollBottom();
        // CSV取得処理（検索条件, ファイル名）
        await this.getCsv(
          this.csvLimit,
          this.searchCondition,
          this.sortCondition,
          '技能者一覧'
        );
      } catch (error) {
        this.csvGetErrorMessage = error.message;
        this.csvGetErrorFlg = true;
      } finally {
        window.removeEventListener('beforeunload', common.confirmSave);
        this.csvGetLodingFlg = false;
      }
    },
    // ソート検索実行
    async onSortChange(params) {
      try {
        // ローディング表示
        this.lodingFlg = true;
        if (params[0].type !== 'none') {
          this.sortCondition = params[0];
        } else {
          this.sortCondition = {};
        }
        // 技能者一覧取得API呼出
        await this.callGetWorkersList();
      } catch (error) {
        throw error;
      } finally {
        // ローディング非表示
        this.lodingFlg = false;
      }
    },
    // ページング処理
    async pagination(moveType) {
      try {
        // ローディング表示
        this.lodingFlg = true;
        if (moveType === 'next' && this.currentPage <= this.maxPage) {
          this.currentPage ++;
          this.inputPage = this.currentPage;
        } else if (moveType === 'back' && this.currentPage >= 1) {
          this.currentPage --;
          this.inputPage = this.currentPage;
        } else {
          return;
        }
        common.scrollTop();
        // 技能者一覧取得API呼出
        await this.callGetWorkersList();
      } catch (error) {
        this.errorMessage = error.message;
        this.getErrorFlg = true;
      } finally {
        // ローディング非表示
        this.lodingFlg = false;
      }
    },
    // ページング番号指定
    async paginationInput() {
      try {
        // ローディング表示
        this.lodingFlg = true;
        if (this.inputPage > this.maxPage || this.inputPage < 1) {
          this.inputPage = this.currentPage;
          return;
        }
        this.currentPage = this.inputPage;
        common.scrollTop();
        await this.callGetWorkersList();
      } catch (error) {
        this.errorMessage = error.message;
        this.getErrorFlg = true;
      } finally {
        // ローディング非表示
        this.lodingFlg = false;
      }
    },
    // ページングフォーカス外し時処理
    paginationBlue() {
      this.inputPage = this.currentPage;
    },
    // CSV出力用共通関数呼出
   // （検索条件,
   async getCsv(limit, searchCondition, sortCondition, pageName) {
     try {
       const restResourceService = new ApiClient();
       const result =  await restResourceService.getWorkersCsv(
         limit, searchCondition, sortCondition
       );
       result.forEach(worker => {
          worker.registrationDate = worker.registrationDate ? common.dateFormat(worker.registrationDate) : '',
          worker.age = worker.birthdate ? common.ageConversion(worker.birthdate) : ''
       });
       // ファイル名用の現在日時
       const currentDate = new Date().getTime();
       const date = common.getToday(currentDate);
       let columns;
       switch(this.role){
        case 'admin':
          columns = this.adminColumns;
          break;
        case 'business':
          columns = this.columns;
          break;
        case 'branch':
          columns = this.branchColumns;
          break;
        default:
          columns = this.columns;
          break;
       }
       const rows = result;
       const fileName = pageName + date;
       common.outputCsv(columns, rows, fileName);
     } catch (error) {
       throw error;
     }
   },
  },
}
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../style/variables.scss";
.modalTitle {
  margin: 30px auto;
  font-weight: bold;
  font-size: $font-medium;
  color: $font_color;
}
.modalYes {
  background-color: $button-primary;
  color: $active_font_color;
  font-size: $font-medium;
  width: 200px;
  height: 50px;
  padding: 10px, 10px;
  margin-bottom: 20px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  outline: none;
  appearance: none;
  font-weight: bold;
}
.modalNo {
  background-color: $button-danger;
  color: $active_font_color;
  font-size: $font-medium;
  width: 200px;
  height: 50px;
  padding: 10px, 10px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  outline: none;
  appearance: none;
  font-weight: bold;
}
.selectdiv {
  position: relative;
  float: left;
  min-width: 500px;
}
.selectdiv:after {
  content: '>';
  font: 17px "Consolas", monospace;
  color: #333;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  right: 11px;
  top: 18px;
  padding: 0 0 2px;
  border-bottom: 1px solid #999;
  position: absolute;
  pointer-events: none;
}
.selectdiv select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: block;
  width: 100%;
  max-width: 500px;
  height: 45px;
  float: right;
  margin: 5px 0px;
  padding: 0px 20px;
  font-size: 14.5px;
  line-height: 1.75;
  color: #333;
  background-color: #ffffff;
  background-image: none;
  border: 2px solid #000000;
  border-radius:10px;
  -ms-word-break: normal;
  word-break: normal;
}
</style>
